// NgRX
import { ActionReducer, createReducer, on } from '@ngrx/store';

// Actions
import {
  DepreciationEffectsActions,
  DepreciationFifthStepEffectsActions,
  DepreciationFirstStepActions,
  DepreciationFirstStepEffectsActions,
  DepreciationFourthStepActions,
  DepreciationFourthStepEffectsActions,
  DepreciationSecondStepEffectsActions, DepreciationSkipEventsStepActions, DepreciationSkipEventsStepEffectsActions,
  DepreciationStepperActions,
  DepreciationThirdStepEffectsActions
} from '../actions/depreciation.actions';

// Models
import {
  Depreciation, DepreciationStatus, FifthStepStatus, FirstStepStatus, FourthStepStatus,
  SecondStepStatus, SkipEventsStepStatus, Step, Tab, ThirdStepStatus, History
} from '@core/models/depreciation.interface';



export const initialState: Depreciation = {
  status: DepreciationStatus.IN_PROGRESS,
  currentStep: 0,
  firstStep: {
    title: 'Selección de periodo',
    status: FirstStepStatus.UNTRIGGERED,
    history: [ ],
    period: null,
    socket: null,
    error: ''
  },
  secondStep: {
    title: 'Carga de vida útil',
    status: SecondStepStatus.UNTRIGGERED,
    file: null,
    error: null
  },
  thirdStep: {
    title: 'Carga CAF',
    status: ThirdStepStatus.UNTRIGGERED,
    file: null,
    socket: null,
    error: null
  },
  skipEventsStep: {
    title: 'Omitir eventos',
    status: SkipEventsStepStatus.UNTRIGGERED,
    tabs: {
      selected: Tab.REGISTERED,
      registered: {
        events: {
          tools: [ ],
          length: 0,
        },
        paginator: {
          page: 1,
          limit: 5
        },
        by: {
          filter: '',
          search: ''
        },
        error: null
      },
      unregistered: {
        events: {
          tools: [ ],
          length: 0,
        },
        paginator: {
          page: 1,
          limit: 5
        },
        by: {
          filter: '',
          search: '',
        },
        error: null
      },
      skipped: {
        events: {
          tools: [ ],
          length: 0,
        },
        paginator: {
          page: 1,
          limit: 5
        },
        by: {
          filter: '',
          search: '',
        },
        error: null
      }
    }
  },
  fourthStep: {
    title: 'Corrección de errores',
    status: FourthStepStatus.UNTRIGGERED,
    tabs: {
      selected: Tab.REGISTERED,
      registered: {
        toolsErrors: {
          tools: [ ],
          length: 0,
          totalMustBeResolved: 0,
          totalReprocessableErrors: 0
        },
        toolError: null,
        page: 1,
        filterBy: {
          typeSearch: '',
          search: '',
          typeError: ''
        },
        error: null
      },
      unregistered: {
        toolsErrors: {
          tools: [ ],
          length: 0,
          totalMustBeResolved: 0,
          totalReprocessableErrors: 0
        },
        toolError: null,
        page: 1,
        filterBy: {
          typeSearch: '',
          search: '',
          typeError: ''
        },
        error: null
      }
    }
  },
  fifthStep: {
    title: 'Envío de archivos',
    status: FifthStepStatus.UNTRIGGERED,
    files: ['', '', ''],
    error: null
  },
};

export const depreciationReducer = createReducer(
  initialState,
  // Stepper
  on(DepreciationEffectsActions.cancelDepreciation, (_state) => {
    return ({ ..._state, error: null, status: DepreciationStatus.CANCEL });
  }),
  on(DepreciationEffectsActions.finalizeDepreciation, (_state) => {
    return ({ ..._state, error: null, status: DepreciationStatus.FINISHED });
  }),
  on(DepreciationStepperActions.first, (_state) => {
    return ({ ..._state, currentStep: Step.ONE });
  }),
  on(DepreciationStepperActions.next, (_state) => {
    let currentStepStatus: any = { }, nextStep: number = _state.currentStep + 1;

    switch (nextStep) {
      case 1: currentStepStatus.firstStep = { ..._state.firstStep, error: null, status: FirstStepStatus.FINISHED }; break;
      case 2: currentStepStatus.secondStep = { ..._state.secondStep, error: null, status: SecondStepStatus.FINISHED }; break;
      case 3: currentStepStatus.thirdStep = { ..._state.thirdStep, error: null, status: ThirdStepStatus.FINISHED }; break;
      case 5:
        currentStepStatus.skipEventsStep = { ..._state.skipEventsStep, error: null, status: SkipEventsStepStatus.FINISHED }; break;
        currentStepStatus.fourthStep = { ..._state.fourthStep, error: null, status: FourthStepStatus.FINISHED }; break;
      case 6: currentStepStatus.fifthStep = { ..._state.fifthStep, error: null, status: FifthStepStatus.FINISHED }; break;
    }

    return ({ ..._state, ...currentStepStatus, error: null, currentStep: Step.FIVE < nextStep ? 0 : nextStep });
  }),
  on(DepreciationStepperActions.previous, (_state) => {
    return ({ ..._state, currentStep: _state.currentStep - 1 });
  }),
  on(DepreciationStepperActions.last, (_state) => {
    return ({ ..._state, currentStep: Step.FIVE });
  }),

  // Store
  on(DepreciationEffectsActions.resetStore, () => {
    return ({ ...initialState });
  }),
  on(DepreciationEffectsActions.injectStore, (_state, { depreciation }) => {
    return ({ ...depreciation });
  }),
  on(DepreciationEffectsActions.injectId, (_state, { id }) => {
    return ({ ..._state, id, error: null });
  }),
  on(DepreciationEffectsActions.injectError, (_state, { error }) => {
    return ({ ..._state, error });
  }),

  // First Step
  // PICKER/CONFIRM Status can't be saved by Server because of we don't have range date selected yet
  // on(DepreciationFirstStepActions.openRangePickerDialog, (_state ) => {
  //   return ({ ...initialState, firstStep: { ...initialState.firstStep, status: FirstStepStatus.PICKER }});
  // }),
  // on(DepreciationFirstStepActions.closeRangePickerDialog, (_state ) => {
  //   return ({ ...initialState, firstStep: { ...initialState.firstStep, status: FirstStepStatus.UNTRIGGERED }});
  // }),
  // on(DepreciationFirstStepActions.openConfirmDateDialog, (_state ) => {
  //   return ({ ...initialState, firstStep: { ...initialState.firstStep, status: FirstStepStatus.CONFIRM }});
  // }),
  // on(DepreciationFirstStepActions.closeConfirmDateDialog, (_state ) => {
  //   return ({ ...initialState, firstStep: { ...initialState.firstStep, status: FirstStepStatus.PICKER }});
  // }),
  on(DepreciationFirstStepEffectsActions.injectHistory, (_state, { history }) => {
    return ({ ..._state, firstStep: { ..._state.firstStep, error: '', history }});
  }),
  on(DepreciationFirstStepActions.injectPeriod, (_state, { period }) => {
    return ({ ...initialState,
      firstStep: {
        ...initialState.firstStep,
        error: '', period,
        history: [ ..._state.firstStep.history ],
        status: FirstStepStatus.SCHEDULED
      }
    });
  }),
  on(DepreciationFirstStepEffectsActions.injectStoreInsteandOfInitLostEvents, (_state, { currentStatus }) => {
    let status: FirstStepStatus;

    switch (currentStatus) {
      // case 'FINISH': status = FirstStepStatus.LOADED; break;
      case 'CREATED': status = FirstStepStatus.SOCKET; break;
      default: status = FirstStepStatus.CANCEL; break;
    }

    return ({ ..._state, firstStep: { ..._state.firstStep, error: '', status }})
  }),
  on(DepreciationFirstStepEffectsActions.injectLostEventsLoadSocket, (_state, { socket }) => {
    let status: FirstStepStatus;

    switch (socket.status) {
      case 'FINISH': status = FirstStepStatus.LOADED; break;
      case 'IN_PROGRESS': status = FirstStepStatus.SOCKET; break;
      default: status = FirstStepStatus.CANCEL; break;
    }

    return ({ ..._state, firstStep: { ..._state.firstStep, error: '', socket, status }})
  }),
  on(DepreciationFirstStepEffectsActions.cancelLostEventsLoadSocket, (_state) => {
    return ({ ..._state, firstStep: { ..._state.firstStep, status: FirstStepStatus.CANCEL }});
  }),
  on(DepreciationFirstStepEffectsActions.injectError, (_state, { error }) => {
    return ({ ..._state, firstStep: { ..._state.firstStep, error, status: FirstStepStatus.ERROR }})
  }),

  // Second Step
  on(DepreciationSecondStepEffectsActions.injectFile, (_state, { file }) => {
    return ({ ..._state, secondStep: { ..._state.secondStep, file: file?.name, error: null, status: SecondStepStatus.FILED }})
  }),
  on(DepreciationSecondStepEffectsActions.injectError, (_state, { error }) => {
    console.error({ error })
    return ({ ..._state, secondStep: { ..._state.secondStep, file: null, error, status: SecondStepStatus.ERROR }});
  }),

  // Third Step
  on(DepreciationThirdStepEffectsActions.injectFile, (_state, { file }) => {
    return ({ ..._state, thirdStep: { ..._state.thirdStep, file: file?.name, error: null, status: ThirdStepStatus.FILED }});
  }),
  on(DepreciationThirdStepEffectsActions.injectError, (_state, { error }) => {
    return ({ ..._state, thirdStep: { ..._state.thirdStep, file: null, error, status: ThirdStepStatus.ERROR }});
  }),
  on(DepreciationThirdStepEffectsActions.injectCafLoadSocket, (_state, { socket }) => {
    let status: ThirdStepStatus;

    switch (socket.status) {
      case 'FINISH': status = ThirdStepStatus.LOADED; break;
      case 'IN_PROGRESS': status = ThirdStepStatus.SOCKET; break;
      default: status = ThirdStepStatus.CANCEL; break;
    }

    return ({ ..._state, thirdStep: { ..._state.thirdStep, error: null, socket, status }, fourthStep: { ...initialState.fourthStep }});
  }),
  on(DepreciationThirdStepEffectsActions.cancelCafLoadSocket, (_state) => {
    return ({ ..._state, thirdStep: { ..._state.thirdStep, status: ThirdStepStatus.CANCEL }});
  }),
  on(DepreciationThirdStepEffectsActions.injectError, (_state, { error }) => {
    return ({ ..._state, thirdStep: { ..._state.thirdStep, error, socket: null, status: ThirdStepStatus.ERROR }});
  }),

  // Skip Events Step
  on(DepreciationSkipEventsStepActions.selectTab, (_state, { selected }) => {
    return ({ ..._state, skipEventsStep: { ..._state.skipEventsStep, tabs: { ..._state.skipEventsStep.tabs, selected }}});
  }),
  on(DepreciationSkipEventsStepEffectsActions.injectSkipEvents, (_state, { events, params }) => {
    console.log({ events, ...params });
    const { skip, eventType, filter, search, page, limit } = params,
      selected = eventType === 'ALTA' ? Tab.REGISTERED : eventType === 'BAJA' ? Tab.UNREGISTERED : Tab.SKIPPED;

    return ({ ..._state, skipEventsStep: { ..._state.skipEventsStep,tabs: {
      ..._state.skipEventsStep.tabs, selected, [selected.toLowerCase()]: { paginator: { page, limit }, by: { filter, search }, events, error: null }
    }, status: SkipEventsStepStatus.ONGOING }});
  }),
  on(DepreciationSkipEventsStepEffectsActions.injectSkipEvent, (_state, { event }) => {
    let property: string =  event.action === 'Omitir' ? event.type === 'Alta' ? 'registered' : 'unregistered' : 'skipped';

    const { events } = (_state.skipEventsStep.tabs as any)[property];
    console.log({ events, property });

    return ({ ..._state, skipEventsStep: { ..._state.skipEventsStep, tabs: {
      ..._state.skipEventsStep.tabs,
    }, status: SkipEventsStepStatus.ONGOING }});
  }),
  on(DepreciationSkipEventsStepEffectsActions.injectError, (_state, { error }) => {
    const selected = _state.skipEventsStep.tabs.selected.toLowerCase();
    console.log({ selected, error });
    return ({ ..._state, skipEventsStep: { ..._state.skipEventsStep, status: SkipEventsStepStatus.ERROR,
      tabs: { ..._state.skipEventsStep.tabs, [selected]: { ...(_state.skipEventsStep.tabs as any)[selected], error }}
    }});
  }),

  // Fourth Step
  on(DepreciationFourthStepActions.selectTab, (_state, { selected }) => {
    return ({ ..._state, fourthStep: { ..._state.fourthStep, tabs: { ..._state.fourthStep.tabs, selected }}});
  }),
  on(DepreciationFourthStepActions.changePage, (_state, { current: page }) => {
    const wrapper: any = { }, property = String(_state.fourthStep.tabs.selected).toLowerCase();
    wrapper[property] = { ...(_state.fourthStep.tabs as any)[property], page };

    return ({ ..._state, fourthStep: { ..._state.fourthStep, tabs: { ..._state.fourthStep.tabs, ...wrapper }}});
  }),
  on(DepreciationFourthStepActions.filterBy, (_state, { typeSearch, search, typeError }) => {
    console.log({ typeSearch, search, typeError });
    const wrapper: any = { }, property = String(_state.fourthStep.tabs.selected).toLowerCase();
    wrapper[property] = { ...(_state.fourthStep.tabs as any)[property], filterBy: { typeSearch, search, typeError }};

    return ({ ..._state, fourthStep: { ..._state.fourthStep, tabs: { ..._state.fourthStep.tabs, ...wrapper }}});
  }),
  on(DepreciationFourthStepEffectsActions.injectRegisteredToolsErrors, (_state, { toolsErrors }) => {
    return ({ ..._state, fourthStep: { ..._state.fourthStep, status: FourthStepStatus.ONGOING,
      tabs: { ..._state.fourthStep.tabs, registered: { ..._state.fourthStep.tabs.registered, toolsErrors, error: null }}
    }});
  }),
  on(DepreciationFourthStepEffectsActions.injectUnregisteredToolsErrors, (_state, { toolsErrors }) => {
    return ({ ..._state, fourthStep: { ..._state.fourthStep, status: FourthStepStatus.ONGOING,
      tabs: { ..._state.fourthStep.tabs, unregistered: { ..._state.fourthStep.tabs.unregistered, toolsErrors, error: null }} }
    });
  }),
  // @ts-ignore
  // on(DepreciationFourthStepEffectsActions.removeRegisteredTool, (_state, { id }) => {
  //   console.log({ id });
  //   return ({
  //     ..._state, fourthStep: { ..._state.fourthStep, error: null,
  //       registeredToolsErrors: {
  //         ..._state.fourthStep.registeredToolsErrors,
  //         tools: _state.fourthStep.registeredToolsErrors.tools.filter(({ id: toolID }) => id !== toolID),
  //       }
  //     },
  //   })
  // }),
  // on(DepreciationFourthStepEffectsActions.removeUnregisteredTool, (_state, { id }) => {
  //   console.log({ id });
  //   return ({
  //     ..._state, fourthStep: { ..._state.fourthStep, error: null,
  //       unregisteredToolsErrors: {
  //         ..._state.fourthStep.unregisteredToolsErrors,
  //         tools: _state.fourthStep.unregisteredToolsErrors.tools.filter(({ id: toolID }) => id !== toolID),
  //       }
  //     },
  //   });
  // }),
  on(DepreciationFourthStepEffectsActions.injectError, (_state, { error }) => {
    const selected = _state.fourthStep.tabs.selected.toLowerCase();
    return ({ ..._state, fourthStep: { ..._state.fourthStep, status: FourthStepStatus.ERROR,
      tabs: { ..._state.fourthStep.tabs, [selected]: { ...(_state.fourthStep.tabs as any)[selected], error }}
    }});
  }),

  // Fifth Step
  on(DepreciationFifthStepEffectsActions.sendReport, (_state) => {
    return ({ ..._state, fifthStep: { ..._state.fifthStep, error: null, status: FifthStepStatus.FINISHED }})
  }),
  on(DepreciationFifthStepEffectsActions.injectError, (_state, { error }) => {
    return ({ ..._state, fifthStep: { ..._state.fifthStep, error, status: FifthStepStatus.ERROR }})
  }),
);


export const depreciationMetaReducer = {
  debug: (reducer: ActionReducer<any>): ActionReducer<any> => (state: any, action: any) => {
    // console.log({ state, action });
    return reducer(state, action);
  },
}
